import {Component} from 'react';
import "./ContactUs/contactUs.css";
import {setHeadersForFetch} from '../../objects/CommonUse/set_headers_for_fetch';
import getCurrentDateTime from '../../objects/CommonUse/get_current_date_time';
// import SendEmail from '../../objects/CommonUse/send_email-save';
import UserSignupModal from './user_signup_modal';
import InformationModal from '../shared-components/information_modal';
import Config from '../../config';
import {buildUrl} from '../../objects/CommonUse/build_URL';

class TeacherParentSignup extends Component {
    constructor(props) {
        super(props);
        this.state={
          openModal: false,
          openInformationModal: false,
          headers: {},
          subProcess: "ContactUs",
          environment: Config.dataURL.currentEnv,
                                   
        };   
        this.typeOfModal = "";
        this.hrefName = 'https://assets.playmoneytrain.com/Parent-Teacher_Startup_Guide.pdf';
    }
    
    
    setTypeOfModal(modalName){
        this.typeOfModal  = modalName;
        this.setState({openModal: true});
    }
    
    closeModals() {
        this.typeOfModal  = "";
        this.setState({openModal: false});
    }
        
    submitContactUsForm(contactUsObj) {
    //    let message = "Subject: " + contactUsObj.subject + " - " + contactUsObj.messageText;
    //    need to combine subject and messageText if using emailjs...    
    //    let fromName = contactUsObj.firstName;
        let userName = sessionStorage.getItem("username");
        if (userName === null){
            userName = "NotSignedIn"
        }
        let toName = "MoneyTrain Game"
    //   this.emailParms={from_name: fromName, userName: userName, to_name: toName, subject: contactUsObj.subject,
    //        message: contactUsObj.messageText, reply_to: contactUsObj.emailAddress};
    //    let templateName=ConfigFile.login.contactTemplate;
    //    let serviceID = ConfigFile.login.contactServiceID;
    //    let publicID = ConfigFile.login.contactPublicID;
    //    console.log("sending email -- template: ", templateName, " service Id: ", serviceID,
    //        " public Id: ", publicID);
        // SendEmail(this.emailParms, templateName, serviceID, publicID);
        this.emailParms = {...contactUsObj, userName: userName, toName: toName}
        this.saveContactUs(); 
        if (contactUsObj.rqstType === "UserSignon"){
            this.informationCode = "SignonEmail";
        }else{
            this.informationCode = "EmailSent";
        }
        this.setState({openInformationModal: true, openModal: false});
    }

    closeInformationModal(){
        this.typeOfModal = "";
        this.setState({openInformationModal: false});
    }
   
    
    render() {
        this.username = sessionStorage.getItem("username");
                                             
    return <>
            <div className="col-8">
                <div className="card mt-1 rounded-corners-lg h-100 container"> 
                    <div className="row">
                        <div className="col-sm-2 ml-4 mt-2">
                            <button className="pages-back-button2" 
                                onClick ={()=> this.props.goBack()}>
                                        Back
                            </button>
                        </div>
                        <div className="col-sm-2"></div>
                        <div className="col-sm-7 ml-4">
                            <h3 className="mt-0 ">Contact Us</h3>
                        </div>
                    </div>
                    <h5 className="text-center">Sign Me Up as a Teacher or Parent</h5>
                    <div className="container my-2">
                        <div className="mx-4 mt-2">
                            <div>
                                A parent or teacher signon is a special type of game access.  The Money Train application
                                supports the ability to have multiple 'related' players for the parent or teacher signon.
                                The person that has the parent or teacher signon can play the game as a regular player.
                                They will also have access to special features in the "For Parents/Teachers"
                                pages. 
                            </div>
                            <div className="mt-3">
                                As a parent or teacher, you can check the game status
                                for your students/children (related players).  There are also video presentations and
                                other resources on the parent/teacher pages that have material that can be used to reinforce and
                                augment the concepts presented in the game.  Once your parent/teacher signon is created,
                                we encourage you to logon and explore the parent/teacher pages of this site.
                            </div>
                            <div className="mt-3">
                                If you are a parent or a teacher, you can click on the <b>"Sign Up As a Teacher or Parent"</b> 
                                button below to gain access to the game.  (There is no charge for the parent/teacher 
                                signon or the related player signons.)  You will be notified (via email), once your signon
                                is created.
                            </div>
                        </div>
                       
                        <span className="row">
                            <div className="col-1 col-md-3 ml-3 ml-md-5">
                            <img  className="small-size-img" src={'./assets/ContactUs/signup.jpg'} 
                                alt="writingPic"/>

                            </div>
                            <div className="col-9 col-md-7 mt-4">
                             
                                {this.typeOfModal  !== "UserSignup" ?
                                    <>
                                        <div className="text-center mt-2 ml-4">
                                            <button className="good-looking-button" 
                                                onClick ={()=> this.setTypeOfModal("UserSignup")}>
                                                Sign Up as a Teacher or Parent
                                            </button>
                                        </div>
                                        <div className="text-center mt-4 ml-4">
                                            <a className="decorative light-blue-color text-pointer" 
                                                href={this.hrefName} target="_blank" 
                                                    rel="noreferrer">
                                                Parent-Teacher Startup Guide PDF
                                            </a>
                                        </div>
                                    </>
                                :
                                    <UserSignupModal openModal={this.state.openModal} 
                                        onClose={() => this.closeModals()} 
                                        onSubmit={(contactUsObj) => this.submitContactUsForm(contactUsObj)}
                                        />
                                }
                            </div>
                            {this.state.openInformationModal   ?
                                <InformationModal  
                                    show={this.state.openInformationModal}
                                    infoCode={this.informationCode}
                                    onClose={() => this.closeInformationModal()}
                                />
                            :
                                null
                            }
                        </span>
                    </div>
                </div>        
            </div>
        </>
    }

    saveContactUs() {
        let headers = {'Content-Type': 'application/json',
            'Authorization': {},
        };
        if (this.emailParms.userName !== "NotSignedIn"){
            headers = setHeadersForFetch();
        }
        let dateObj = getCurrentDateTime();
        let bodyObj = {
            fromName: this.emailParms.firstName,
            toName: this.emailParms.toName,
            userName: this.emailParms.userName,
            subject: this.emailParms.subject,
            message: this.emailParms.message,
            emailType: this.emailParms.emailType,
            formData: this.emailParms.formData,
            replyTo: this.emailParms.emailAddress,
            dateAdded: dateObj.date,
            timeAdded: dateObj.time
        };
        const funcName = "saveContactUsEmail";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
      
        fetch(uri,
            {
            method:'post',
            headers: headers,
            body: JSON.stringify(bodyObj)
            })
            .then(response => {
                    if (response.ok){
                        response.json().then(data => {
                            const output = JSON.parse(data);
                            const statusCode = output.statusCode;
                            if (statusCode === 200){
                                // save of email data was successful!!
                            }else{
                                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                    status: statusCode, message: output.body.message, errorObject: bodyObj};
                                this.props.processError(errorObj);
                            }
                    });
                };
        });
             
    }
 
}

export default TeacherParentSignup;